import qs from '../../utilities/query-string';
import React, { Component, Fragment } from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import SideContainer from "../../components/side-container/side-container-component";
import Filters from "../../modules/filters/filters-container";
import MainContainer from "../../components/main-container/main-container-component";
import Container from "../../components/container/container-component";
import {changeReportUrl} from "../../modules/report/report-action-creators";
import ReportInfo from "../../modules/report-info/report-info-container";


const withFilters = Comp => {

  class Wrapper extends Component {

    constructor(props) {
      super(props);
      const reportUrl = qs.parse(this.props.location.search).reportUrl;
      this.props.changeReportUrl(reportUrl);
    }

    render() {
      return (
        <Container
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          {
            this.props.reportUrl
              ?
              <Fragment>
                <SideContainer>
                  <Filters />
                </SideContainer>

                <MainContainer>

                  <div className="report_info_container">
                    <ReportInfo />
                  </div>
                  <div style={{width: '100%', padding: '10px'}}>
                    <Comp {...this.props} />
                  </div>
                </MainContainer>
              </Fragment>
              :
              <span style={{alignSelf: 'center'}}>Report url should be provided</span>
          }
        </Container>
      )
    }
  }

  const mapStateToProps = state => ({
    filters: state.filters.filters,
    filtersToSend: state.filters.filtersToSend,
    reportUrl: state.report.reportUrl
  });


  const mapDispatchToProps = dispatch => ({
    changeReportUrl: reportUrl => dispatch(changeReportUrl(reportUrl))
  });


  return withRouter(connect(mapStateToProps, mapDispatchToProps)(Wrapper))

};


export default withFilters;



// WEBPACK FOOTER //
// ./src/hoc/with-filters/with-filters-hoc.js